(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pp-stock-badge"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pp-live-stock')) {
    customElements.define('pp-live-stock', class extends HTMLElement {
      connectedCallback() {
        this.frame = requestAnimationFrame(() => this.start());
      }
      start() {
        this.root = document.getElementById('pp-' + this.dataset.sectionId);
        if (!this.root || !this.isConnected) return;
        this.onChange = (event) => {
          if (event.target.matches('.pp-form [name="id"]')) {
            this.hidden = true;
            this.refresh();
          }
        };
        this.onVisible = () => { if (!document.hidden) this.refresh(); };
        this.root.addEventListener('change', this.onChange);
        document.addEventListener('visibilitychange', this.onVisible);
        window.addEventListener('pageshow', this.onVisible);
        this.timer = setInterval(() => {
          if (!document.hidden) this.refresh();
        }, 60000);
        this.refresh();
      }
      variantId() {
        return this.root.querySelector('.pp-form [name="id"]')?.value || this.dataset.variantId;
      }
      async refresh() {
        if (!this.isConnected || !this.root) return;
        this.request?.abort();
        const controller = new AbortController();
        this.request = controller;
        const timeout = setTimeout(() => controller.abort(), 12000);
        const variantId = this.variantId();
        const url = new URL(window.location.href);
        url.hash = '';
        url.searchParams.delete('sections');
        url.searchParams.delete('sections[]');
        url.searchParams.set('section_id', this.dataset.sectionId);
        url.searchParams.set('variant', variantId);
        url.searchParams.set('_pp_stock', Date.now().toString());
        try {
          const response = await fetch(url, {
            credentials: 'same-origin',
            cache: 'no-store',
            signal: controller.signal,
            headers: { Accept: 'text/html' }
          });
          if (!response.ok) throw new Error('Stock request failed');
          const html = await response.text();
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const fresh = doc.getElementById('pp-' + this.dataset.sectionId)?.querySelector('pp-live-stock');
          if (!fresh || fresh.dataset.variantId !== variantId) throw new Error('Stock variant mismatch');
          if (this.request !== controller || !this.isConnected || variantId !== this.variantId()) return;
          if (this.innerHTML !== fresh.innerHTML) this.innerHTML = fresh.innerHTML;
          this.dataset.state = fresh.dataset.state;
          this.dataset.variantId = variantId;
          this.hidden = false;
        } catch (error) {
          if (this.request === controller && this.isConnected) this.hidden = true;
        } finally {
          clearTimeout(timeout);
        }
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        clearInterval(this.timer);
        this.request?.abort();
        this.root?.removeEventListener('change', this.onChange);
        document.removeEventListener('visibilitychange', this.onVisible);
        window.removeEventListener('pageshow', this.onVisible);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
